import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Alert, Button, Spinner, Table, } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form } from './Form';
import { Details } from './Details';
import { PageStatus } from 'enums';
import { Show } from "../../Layout";
import CardHeader from "../Card/CardHeader";
import GridContainer from "../Grid/GridContainer";
import moment from "moment/moment";
import { PartnersAPI } from "../../API";
import ShowDataAccording2PageSize from 'Components/ShowEntries/ShowEntries';
import PaginationNumbering from 'Components/ShowEntries/Pagination';
import { Confirmation } from 'Shared/Confirmation';
import LanguageContext from "../../Layout/LanguageContext";
import { pageDict } from "../../Languages/PageTranslations";
import { toast } from 'react-toastify';

const MODAL_TYPES = {
    NONE: 'NONE',
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    DETAILS: 'DETAILS',
};

type State = {
    status: PageStatus,
    error: string | null,
    formType: string,
    clients: any[],
    id?: string | null,
    pageSize: any,
    currentPageNumber: any,
    totalResponseData: any,
    totalResponsePages: any,
};

class ClientsListComponent extends Component<any, any> {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);
        this.state = {
            status: PageStatus.None,
            error: null,
            formType: MODAL_TYPES.NONE,
            id: null,
            clients: [],
            pageSize: 10,
            currentPageNumber: 1,
            totalResponseData: '',
            totalResponsePages: '',
        };
        this.fetchList = this.fetchList.bind(this);
    }

    componentDidMount() {
        this.fetchList();
    }

    fetchList(): Promise<void> {
        const { pageSize, currentPageNumber } = this.state;
        return Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => PartnersAPI.getAllClients(pageSize, currentPageNumber))
            .then((data) => {
                this.setState({ clients: data.data, totalResponseData: data.totalCount, totalResponsePages: data.totalPage, status: PageStatus.Loaded });
            })
            .catch((error) => {
                this.setState({ error: error.message, status: PageStatus.Error });
            });
    }

    isShowDetailModal(): boolean {
        return this.state.formType === MODAL_TYPES.DETAILS
            || this.state.formType === MODAL_TYPES.DELETE;
    }

    // Hey! Sonar qube, Please ignore the below code
    // onCloseModalFunc(): void {
    //     this.setState({ formType: MODAL_TYPES.NONE });
    // }

    deleteClientData(id): Promise<void> {
        return Promise.resolve()
        .then(() => this.setState({ status: PageStatus.Loading }))
        .then(() => PartnersAPI.deleteClientsDetails(id))
        .then(() => { toast.success("Client deleted successfully"); this.setState({ status: PageStatus.Loaded, }, ()=> {this.fetchList()}); })
        .catch((error) => {
            toast.error(error.message || "Failed to delete client");
            this.setState({ error: error.message, status: PageStatus.Error });
        });
    }

    handlePageSizeChange = (newValue: any) => { this.setState({ pageSize: newValue, currentPageNumber: 1 }); };
    handlePageNumberChange = (newValue: any) => { this.setState({ currentPageNumber: newValue }); };

    componentDidUpdate(prevProps: {}, prevState: State) {
        if (prevState.pageSize !== this.state.pageSize || prevState.currentPageNumber !== this.state.currentPageNumber) { this.fetchList(); }
    };

    render() {
        const { pageSize, currentPageNumber, totalResponseData, totalResponsePages } = this.state;
        const lang = this.context || 'en';
        const t = (key) => (pageDict[lang] && pageDict[lang][key]) || pageDict['en'][key] || key;
        return (
            <>
                <GridContainer>
                    <div className='w-100 mb-3'>
                        <CardHeader color="primary">
                            <div className="d-flex align-items-center justify-content-between">
                                <h4>{t("Clients")}</h4>
                                <div>
                                    {this.props.role !== 'sales' && (<Button
                                        onClick={() => {
                                                return this.setState({
                                                    formType: MODAL_TYPES.CREATE,
                                                });
                                            }}
                                        variant="primary"
                                        size="sm"
                                        className="mx-1"
                                    >
                                            <FontAwesomeIcon icon={['fas', 'plus']} className="mr-2" />
                                        {t("Create")}
                                        </Button>)}
                                </div>
                            </div>
                        </CardHeader>
                    </div>
                </GridContainer>
                <div className="jumbotron bg-white p-3 border shadow-sm">
                    <Alert variant="danger" show={this.state.status === PageStatus.Error}>
                        {this.state.error}
                    </Alert>

                    <Show when={this.state.status === PageStatus.Loading}>
                        <div className="d-flex justify-content-center w-100 p-5">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    </Show>

                    <Show when={this.state.status === PageStatus.Loaded}>
                        <Show when={this.state.formType === MODAL_TYPES.CREATE || this.state.formType === MODAL_TYPES.UPDATE}>
                            <Form
                                show={this.state.formType === MODAL_TYPES.CREATE || this.state.formType === MODAL_TYPES.UPDATE}
                                onClose={() => this.setState({
                                    formType: MODAL_TYPES.NONE,
                                })}
                                onSubmit={(id) => {
                                    this.fetchList();
                                    this.setState({
                                        formType: MODAL_TYPES.DETAILS, id: id,
                                    });
                                }}
                                id={this.state.formType === MODAL_TYPES.UPDATE ? this.state.id : null}
                            />
                        </Show>

                        <Show when={!this.state.clients.length}>
                            <Alert variant="info" show={!this.state.clients.length}>
                                {t("No data is available")}
                            </Alert>
                        </Show>

                        <Show when={!!this.state.clients.length}>
                            <Show when={this.isShowDetailModal()}>
                                <Details
                                    id={this.state.id}
                                    role={this.props.role}
                                    onClose={() => this.setState({
                                        formType: MODAL_TYPES.NONE,
                                        id: null,
                                    })}
                                    onUpdate={() => {
                                        this.setState({
                                            formType: MODAL_TYPES.UPDATE,
                                        });
                                    }}
                                    onDelete={(id) => {
                                        this.setState({
                                            formType: MODAL_TYPES.DELETE,
                                            id: id,
                                        });
                                    }}
                                />
                            </Show>
                            <div>
                                <div className='mb-2'>
                                    <ShowDataAccording2PageSize
                                        currentPageSize={pageSize}
                                        currentPage={currentPageNumber}
                                        sendPageSize={this.handlePageSizeChange}
                                        showTotalData={totalResponseData}
                                        sendLastPage={totalResponsePages}
                                    />
                                </div>
                                <Table responsive size="sm" bordered>
                                    <thead>
                                        <tr>
                                            <th>{t("S.No")}</th>
                                            <th>{t("Company Name")}</th>
                                            <th>{t("Contact Name")}</th>
                                            <th>{t("Number")}</th>
                                            <th>{t("Email")}</th>
                                            <th>{t("State")}</th>
                                            <th>{t("City")}</th>
                                            <th>{t("Zip Code")}</th>
                                            <th>{t("Country")}</th>
                                            <th>{t("CreatedAt")}</th>
                                            <th>{t("UpdatedAt")}</th>
                                            {this.props.role !== 'sales' && <th>{t("Action")}</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.clients.map((data, index) => (
                                                <tr key={data.id}>
                                                    <td>{((pageSize) * (currentPageNumber - 1)) + (index + 1)}</td>
                                                    <td className='text-start'>
                                                        <button
                                                            className="text-primary bg-transparent text-start d-block"
                                                            onKeyPress={() => null}
                                                            onClick={() => {
                                                                this.setState({
                                                                    formType: MODAL_TYPES.DETAILS,
                                                                    id: data.id,
                                                                });
                                                            }}
                                                            >
                                                            <div
                                                                style={{ textAlign: "left", display: "block", whiteSpace: "normal" }}
                                                                dangerouslySetInnerHTML={{
                                                                    __html: data.name || 'Title',
                                                                }}
                                                            ></div>
                                                        </button>
                                                    </td>
                                                    <td>{data.contactName}</td>
                                                    <td>{data.number}</td>
                                                    <td>{data.email}</td>
                                                    <td>{data.state}</td>
                                                    <td>{data.city}</td>
                                                    <td>{data.zipCode}</td>
                                                    <td>{data.country}</td>
                                                    <td>{moment(data.createdAt).format('MM/DD/YYYY HH:mm A')}</td>
                                                    <td>{moment(data.updatedAt).format('MM/DD/YYYY HH:mm A')}</td>
                                                    {this.props.role !== 'sales' && <td>
                                                        <Confirmation onAction={() => this.deleteClientData(data.id)} body={t("Are you sure want to delete this client?")}>
                                                            <button className='btn btn-danger btn-sm' >{t("Delete")}</button>
                                                        </Confirmation>
                                                    </td>}
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </Table>
                                <div>
                                    <PaginationNumbering
                                        currentPage={currentPageNumber}
                                        returnPagenumber={this.handlePageNumberChange}
                                        showTotalData={totalResponseData}
                                        sendLastPage={totalResponsePages}
                                    />
                                </div>
                            </div>
                        </Show>
                    </Show>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state: any) => ({
  role: state.adminUser?.adminUser?.role,
});

export const ClientsList = connect(mapStateToProps)(ClientsListComponent);
